import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Menu, X, Phone, Home, Play, LogIn, PlusCircle, LayoutDashboard } from "lucide-react";
import probrokerLogo from "../assets/probroker-logo.png";
import { motion, AnimatePresence } from "framer-motion";
import Cookies from "js-cookie";

const Navbar1 = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const isLoggedIn = !!Cookies.get("userId");

  return (
    <>
      <nav className="absolute top-0 left-0 right-0 z-50 bg-transparent">
        <div className="container mx-auto px-4 sm:px-6 lg:px-[85px] relative z-10 ">
          <div className="flex items-center justify-between h-16 sm:h-[72px]">
            {/* Logo */}
            <a href="#" className="flex-shrink-0">
              <img
                src={probrokerLogo}
                alt="PRObroker"
                className="h-7 sm:h-8 w-auto brightness-0 invert"
              />
            </a>

            {/* Desktop Nav */}
            <div className="hidden lg:flex items-center gap-6">
              <Link
                to="/"
                className="text-sm font-medium text-white/70 hover:text-white transition-colors"
              >
                Home
              </Link>
              <a
                href="#demo"
                className="text-sm font-medium text-white/70 hover:text-white transition-colors"
              >
                Live Demo
              </a>
         <Link
  to="https://ownerlisting.probroker.in/"
  className="text-sm font-medium px-4 py-2 rounded-full bg-primary text-primary-foreground hover:bg-primary/90 transition-colors flex items-center gap-2"
>
  Add Owner Property 
  <span className="bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 text-black text-xs font-semibold px-2 py-0.5 rounded-full">
    FREE
  </span>
</Link>
              <a
                href="tel:8141817353"
                className="text-sm font-medium text-white/70 hover:text-white transition-colors flex items-center gap-1.5"
              >
                <Phone className="w-3.5 h-3.5" />
                8141817353
              </a>
            </div>

            {/* Login/Dashboard Button */}
            <div className="hidden lg:flex items-center">
              {isLoggedIn ? (
                <Link to="/dashboard">
                  <Button
                    variant="outline"
                    size="sm"
                    className="text-sm h-9 px-5 rounded-full border-white/25 text-white hover:bg-white/10 hover:border-white/40 bg-transparent flex items-center gap-2"
                  >
                    <LayoutDashboard className="w-4 h-4" />
                    Dashboard
                  </Button>
                </Link>
              ) : (
                <Link to="/login">
                  <Button
                    variant="outline"
                    size="sm"
                    className="text-sm h-9 px-5 rounded-full border-white/25 text-white hover:bg-white/10 hover:border-white/40 bg-transparent"
                  >
                    Login
                  </Button>
                </Link>
              )}
            </div>

            {/* Mobile Toggle */}
            <button
              className="lg:hidden p-2 text-white"
              onClick={() => setMobileOpen(true)}
            >
              <Menu className="w-5 h-5" />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Sidebar */}
      <AnimatePresence>
        {mobileOpen && (
          <>
            {/* Overlay */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="fixed inset-0 z-[60] bg-black/50"
              onClick={() => setMobileOpen(false)}
            />
            {/* Panel */}
            <motion.div
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "spring", damping: 30, stiffness: 300 }}
              className="fixed top-0 right-0 bottom-0 z-[70] w-[80%] max-w-[320px] bg-white shadow-2xl flex flex-col"
            >
              {/* Header - close button only */}
              <div className="flex items-center justify-end px-5 py-4">
                <button
                  onClick={() => setMobileOpen(false)}
                  className="p-2 rounded-full hover:bg-muted transition-colors"
                >
                  <X className="w-5 h-5 text-muted-foreground" />
                </button>
              </div>

              {/* Nav Links */}
              <div className="flex-1 px-4 py-2 flex flex-col">
                <Link
                  to="/"
                  className="flex items-center gap-3 px-4 py-4 text-[15px] font-medium text-foreground hover:bg-muted rounded-xl transition-colors"
                  onClick={() => setMobileOpen(false)}
                >
                  <Home className="w-5 h-5 text-primary" />
                  Home
                </Link>
                <a
                  href="#demo"
                  className="flex items-center gap-3 px-4 py-4 text-[15px] font-medium text-foreground hover:bg-muted rounded-xl transition-colors"
                  onClick={() => setMobileOpen(false)}
                >
                  <Play className="w-5 h-5 text-primary" />
                  Live Demo
                </a>
                <a
                  href="tel:8141817353"
                  className="flex items-center gap-3 px-4 py-4 text-[15px] font-medium text-foreground hover:bg-muted rounded-xl transition-colors"
                  onClick={() => setMobileOpen(false)}
                >
                  <Phone className="w-5 h-5 text-primary" />
                  Call 8141817353
                </a>

                {/* Buttons */}
                <div className="mt-6 pt-6 border-t border-border flex flex-col gap-3 px-2">
                  <Link
                    to="https://ownerlisting.probroker.in/"
                    className="flex items-center justify-center gap-2 w-full text-[15px] font-semibold px-4 py-3.5 rounded-xl bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
                    onClick={() => setMobileOpen(false)}
                  >
                    <PlusCircle className="w-4.5 h-4.5" />
                    Add Owner Property (Free)
                  </Link>
                  {isLoggedIn ? (
                    <Link to="/dashboard" onClick={() => setMobileOpen(false)}>
                      <Button
                        variant="outline"
                        className="w-full rounded-xl h-12 border-primary/30 text-primary hover:bg-primary/5 font-semibold text-[15px]"
                      >
                        <LayoutDashboard className="w-4.5 h-4.5 mr-2" />
                        Dashboard
                      </Button>
                    </Link>
                  ) : (
                    <Link to="/login" onClick={() => setMobileOpen(false)}>
                      <Button
                        variant="outline"
                        className="w-full rounded-xl h-12 border-primary/30 text-primary hover:bg-primary/5 font-semibold text-[15px]"
                      >
                        <LogIn className="w-4.5 h-4.5 mr-2" />
                        Login
                      </Button>
                    </Link>
                  )}
                </div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar1;
